export default "__VITE_PUBLIC_ASSET__907906dc__"